export default __webpack_public_path__ + "static/media/pakaian.7e3305c4.png";